import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Row, Card, Col, Radio, Button, DatePicker, Popover, Form, Input, Drawer } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegTimesCircle, FaTimes, FaSearch, FaFilter, FaEdit } from "react-icons/fa";
import { fetchOneWayFlightList } from '../../../redux/flight/flightOneWaySlice';
import dayjs from 'dayjs';
import moment from 'moment';
import { fetchFlightCountryList } from '../../../redux/flight/flightSearchListSlice';
import { topTanCity, travelersClass } from '../../../utils/Constants';
import { fetchRoundCityFlightFilterList } from '../../../redux/flight/flightRoundCityFlightSlice';
import { clearAllFilters } from '../../../redux/flight/flightFilterSlice';
import { clearAllFiltersRoundTrip } from '../../../redux/flight/flightRoundTripFilterSlice';
import { fetchFlightContent } from '../../../redux/flight/flightSlice';
import { setCities } from '../../../redux/flight/citySlice';
import RoundTripFilter from './RoundTripFilter';
import ResultFilter from './ResultFilter';
import { icons } from '../../../assets/iconsPath';

const SearchFlightsUpdate = ({
    setArrivalDataReturn,
    setDepartureData,
    setSelectedValueReturn,
    setSelectedValue,
    setShouldLoadOnward,
    setShouldLoadReturn
}) => {

    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleRoundTrip, setIsVisibleRoundTrip] = useState(null)
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
    const bannerSearch = useRef(null);



    const showSearch = () => {
        setIsSearchVisible(false);
    };

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.innerWidth <= 768;
            setIsMobileView(isMobile);
            if (!isMobile) {
                setIsSearchVisible(true);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);



    const dispatch = useDispatch();
    const location = useLocation();

    // const getFromSessionStorage = (key, defaultValue = null) => {
    //     const value = sessionStorage.getItem(key);
    //     if (value === null || value === undefined) {
    //         return defaultValue;
    //     }
    //     try {
    //         return JSON?.parse(value);
    //     } catch (e) {
    //         console.error(`Error parsing sessionStorage key "${key}":`, e);
    //         return defaultValue;
    //     }
    // };

    const STORAGE_KEY = "DepartureFlight";

    const getFromSessionStorage = (key, defaultValue = null) => {
        const value = sessionStorage.getItem(key);
        if (!value) return defaultValue;
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(`Error parsing localStorage key "${key}":`, e);
            return defaultValue;
        }
    };

    const flightData = {
        selectFromCity: getFromSessionStorage('selectFromCity'),
        selectFromCityName: getFromSessionStorage('selectFromCityName'),
        selectTOCity: getFromSessionStorage('selectTOCity'),
        selectTOCityName: getFromSessionStorage('selectTOCityName'),
        selectAdultsFlight: getFromSessionStorage('selectAdultsflight'),
        selectChildFlight: getFromSessionStorage('selectChildflight'),
        selectInfantsFlight: getFromSessionStorage('selectInfantsflight'),
        seatTypeFlight: getFromSessionStorage('seatTypeflight'),
        returnFlight: getFromSessionStorage('returnFlight'),
        findDayReturnFlight: getFromSessionStorage('findDayReturnFlight')
    };

    const dateFormat = 'DD/MMM/YYYY';
    const urlDateFormat = 'YYYY-MM-DD';
    const currentFormattedDate = dayjs().add(1, 'day').format(dateFormat);
    // const [findDay, setFindDay] = useState(flightData.departureFlight || currentFormattedDate);
    // const [findDay, setFindDay] = useState(() => {
    //     return getFromSessionStorage(STORAGE_KEY, dayjs().add(1, "day").format(dateFormat));
    // });
    // const [findDay, setFindDay] = useState(() => {
    //     const searchParams = new URLSearchParams(window.location.search);
    //     const departureDateFromURL = searchParams.get('departure_date');
    //     if (departureDateFromURL) {
    //         let parsedDate = null;

    //         if (moment(departureDateFromURL, urlDateFormat, true).isValid()) {
    //             parsedDate = moment(departureDateFromURL, urlDateFormat);
    //         }
    //         else if (moment(departureDateFromURL, dateFormat, true).isValid()) {
    //             parsedDate = moment(departureDateFromURL, dateFormat);
    //         }
    //         if (parsedDate) {
    //             const today = moment().startOf('day');
    //             if (parsedDate.isBefore(today)) {
    //                 return moment().add(1, 'day').format(dateFormat);
    //             } else {
    //                 return parsedDate.format(dateFormat);
    //             }
    //         }
    //     }
    //     const sessionDate = getFromSessionStorage(STORAGE_KEY);
    //     if (sessionDate) {
    //         return moment(sessionDate, [dateFormat, urlDateFormat]).format(dateFormat);
    //     }
    //     return moment().add(1, 'day').format(dateFormat);
    // });

    const [findDay, setFindDay] = useState(() => {
        const searchParams = new URLSearchParams(window.location.search);
        // const departureURL = searchParams.get("departure_date");
        // if (departureURL) {
        //     const parsed = moment(departureURL, [urlDateFormat, dateFormat], true);
        //     if (parsed.isValid()) {
        //         return parsed.format(dateFormat);
        //     }
        // }
        const departureDateFromURL = searchParams.get('departure_date');
        if (departureDateFromURL) {
            let parsedDate = null;

            if (moment(departureDateFromURL, urlDateFormat, true).isValid()) {
                parsedDate = moment(departureDateFromURL, urlDateFormat);
            }
            else if (moment(departureDateFromURL, dateFormat, true).isValid()) {
                parsedDate = moment(departureDateFromURL, dateFormat);
            }
            if (parsedDate) {
                const today = moment().startOf('day');
                if (parsedDate.isBefore(today)) {
                    return moment().add(1, 'day').format(dateFormat);
                } else {
                    return parsedDate.format(dateFormat);
                }
            }
        }
        const sessionDate1 = getFromSessionStorage(STORAGE_KEY);
        if (sessionDate1) {
            const parsed = moment(sessionDate1, [dateFormat, urlDateFormat], true);
            if (parsed.isValid()) return parsed.format(dateFormat);
        }

        const sessionDate2 = sessionStorage.getItem("DepartureFlight");
        if (sessionDate2) {
            const parsed = moment(sessionDate2, [dateFormat, urlDateFormat], true);
            if (parsed.isValid()) return parsed.format(dateFormat);
        }

        return moment().add(1, "day").format(dateFormat);
    });

    // const [findDayRetrun, setFindDayRetrun] = useState(flightData?.findDayReturnFlight);

    const [findDayRetrun, setFindDayRetrun] = useState(() => {
        const sessionReturn = sessionStorage.getItem("findDayReturnFlight");
        return sessionReturn ? moment(sessionReturn).format(dateFormat) : null;
    });
    // 🔥 Listen for changes from updateDate()
    useEffect(() => {
        const handleStorage = () => {
            const sessionReturn = sessionStorage.getItem("findDayReturnFlight");
            if (sessionReturn) {
                setFindDayRetrun(moment(sessionReturn).format(dateFormat));
            }

            const sessionDepart = sessionStorage.getItem(STORAGE_KEY);
            if (sessionDepart) {
                setFindDay(moment(sessionDepart).format(dateFormat));
            }
        };

        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);
    const [selectAdults, setSelectAdults] = useState(flightData?.selectAdultsFlight || 1);
    const [selectchildren, setSelectchildren] = useState(flightData?.selectChildFlight || 0);
    const [selectInfants, setSelectInfants] = useState(flightData?.selectInfantsFlight || 0)
    const [errorSameCitySelect, setErrorSameCitySelect] = useState(false)
    const [returnFlights, setReturnFlight] = useState(flightData?.returnFlight || "oneWay")
    const [seatType, setSeatType] = useState(flightData?.seatTypeFlight || "ECONOMY")
    const [selectedFromCity, setSelectedFromCity] = useState(flightData?.selectFromCity || '');
    const [selectedTocity, setSelectedTocity] = useState(flightData?.selectTOCity || '');
    const [returnFlightComp, setReturnFlightComp] = useState(false);
    const [showSearchListFrom, setShowSearchListFrom] = useState(false);
    const [showSearchListTo, setShowSearchListTo] = useState(false);
    const [topCityData, setTopCityData] = useState(true);
    const [searchTermFrom, setSearchTermFrom] = useState('');
    const [searchTermTo, setSearchTermTo] = useState('');
    const oneWayFlightData = useSelector((state) => state.flightOneWay.oneWayFlightData);
    const roundCityFlightFilterData = useSelector((state) => state.flightRoundCity.roundCityFlightFilterData);
    const loading = useSelector((state) => state.flightOneWay.loading);
    const loadingRoundTrip = useSelector((state) => state.flightRoundCity.filterLoading);
    const [infantsError, setInFantError] = useState(null);
    const [isButtonClick, setIsButtonClick] = useState(false);
    const formattedFromCity = selectedFromCity?.toLowerCase().replace(/\s+/g, '-');
    const formattedToCity = selectedTocity?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
    const resultUrl = `/flights/${urlIdDynamic}`;

    useEffect(() => {
        const handleStorageChange = () => {
            const updatedDate = sessionStorage.getItem(STORAGE_KEY);
            if (updatedDate) {
                setFindDay(updatedDate);
            }
        };

        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);


    const handleClearFilters = () => {
        dispatch(clearAllFilters({ oneWayFlightData }));
        dispatch(clearAllFiltersRoundTrip({ roundCityFlightFilterData }))
    };

    const addAdults = () => {
        if (selectAdults < 10) {
            setSelectAdults((prevAdults) => {
                const newAdults = prevAdults + 1;
                if (selectInfants <= newAdults) {
                    setInFantError(false);
                }
                return newAdults;
            });
        }
    };

    const removeAdults = () => {
        if (selectAdults > 1) {
            setSelectAdults((prevAdults) => {
                const newAdults = prevAdults - 1;
                if (selectInfants > newAdults) {
                    setInFantError(true);
                } else {
                    setInFantError(false);
                }
                return newAdults;
            });
        }
    };

    const addInfants = () => {
        setSelectInfants((prevSelectInfants) => {
            const newSelectInfants = prevSelectInfants + 1;
            if (newSelectInfants > selectAdults) {
                setInFantError(true);
            } else {
                setInFantError(false);
            }
            return newSelectInfants;
        });
    };

    const removeInfants = () => {
        setSelectInfants((prevSelectInfants) => {
            if (prevSelectInfants > 0) {
                const newSelectInfants = prevSelectInfants - 1;
                if (newSelectInfants > selectAdults) {
                    setInFantError(true);
                } else {
                    setInFantError(false);
                }
                return newSelectInfants;
            }
            return prevSelectInfants;
        });
    };

    const addChildern = () => {
        if (selectchildren < 10) {
            setSelectchildren(selectchildren + 1);
        }
    }

    const removeChildern = () => {
        if (selectchildren > 0) {
            setSelectchildren(selectchildren - 1);
        }
    }

    const onChangeTrip = (e) => {
        const { value } = e.target;
        setReturnFlight(value);
        setReturnFlightComp(true);
        sessionStorage.removeItem("comeFromReview");
    };

    const roundTrip = () => {
        setReturnFlight("roundTrip");
        setReturnFlightComp(true);
    };

    const crossReturnDate = () => {
        setReturnFlight("oneWay");
        setReturnFlightComp(false);
    }


    const datePickerRef = useRef(null);
    const wrapperRef = useRef(null);
    const datePickerRefReturn = useRef(null);
    const wrapperRefReturn = useRef(null);
    const [isDatePickerOpen1, setIsDatePickerOpen1] = useState('');
    const [isDatePickerOpen1Return, setIsDatePickerOpen1Return] = useState('');
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [isDatePickerOpenReturn, setIsDatePickerOpenReturn] = useState(false);



    const onChangeDeparture = (date, dateString) => {
        navigate(resultUrl);
        setIsDatePickerOpen1(dateString);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(dateString));
        setFindDay(dateString);
        sessionStorage.removeItem('airlineName');
        window.dispatchEvent(new Event("storage"));
        const selectedDate = dayjs(dateString, dateFormat);
        const currentReturnDate = new Date(findDayRetrun)
        if (!findDayRetrun || selectedDate >= currentReturnDate) {
            const updatedReturnDate = selectedDate.add(1, 'day').format(dateFormat);
            setFindDayRetrun(updatedReturnDate);
        }
        setIsDatePickerOpen(false);
        if (returnFlights === "roundTrip") {
            setTimeout(() => {
                setIsDatePickerOpenReturn(true);
            }, 100);
        }
    };





    const handleDivClick = () => {
        setIsDatePickerOpen(true);
        setIsDatePickerOpenReturn(false);
    };

    const handleDivClickReturn = () => {
        setIsDatePickerOpenReturn(true);
        setIsDatePickerOpen(false);
    };

    const onChangeReturn = (date, dateString) => {
        setIsDatePickerOpenReturn(false);
        setIsDatePickerOpen1Return(dateString)
        sessionStorage.removeItem('airlineName');
        setFindDayRetrun(dateString)
    }

    const disabledPastDate = (current) => {
        return current && current < moment().startOf('day');
    };


    const handleClickOutside = (event) => {

        if (
            datePickerRef.current instanceof HTMLElement &&
            !datePickerRef.current.contains(event.target) &&
            wrapperRef.current instanceof HTMLElement &&
            !wrapperRef.current.contains(event.target)
        ) {
            setIsDatePickerOpen(false);
        }

        // Check if datePickerRefReturn and wrapperRefReturn are attached to a valid DOM element
        if (
            datePickerRefReturn.current instanceof HTMLElement &&
            !datePickerRefReturn.current.contains(event.target) &&
            wrapperRefReturn.current instanceof HTMLElement &&
            !wrapperRefReturn.current.contains(event.target)
        ) {
            setIsDatePickerOpenReturn(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setIsDatePickerOpen(false);
        setIsDatePickerOpenReturn(false);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDatePickerOpen1, isDatePickerOpen1Return]);


    const [open, setOpen] = useState(false);
    const { flightList } = useSelector((state) => state.flightList);
    const popoverFromRef = useRef(null);
    const popoverToRef = useRef(null);

    const debounce = (func, delay) => {
        let debounceTimer;
        return function (...args) {
            const context = this;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    };

    const fetchCountryList = useCallback(
        debounce((term) => {
            dispatch(fetchFlightCountryList(term));
        }, 500),
        []
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverFromRef.current && !popoverFromRef.current.contains(event.target)) {
                setShowSearchListFrom(false);
                setTopCityData(true)
                setErrorSameCitySelect(false)
            }
            if (popoverToRef.current && !popoverToRef.current.contains(event.target)) {
                setShowSearchListTo(false);
                setTopCityData(true)
                setErrorSameCitySelect(false)
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const inputRef = useRef(null);

    useEffect(() => {
        if (showSearchListFrom && inputRef.current) {
            inputRef.current.focus();
        }
        if (showSearchListTo && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showSearchListFrom, showSearchListTo]);

    const handleSelectFromFlight = (flight) => {
        if (flight.cityCode === selectedTocity) {
            setErrorSameCitySelect(true);
            return;
        }

        setSelectedFromCity(flight?.city);
        setSelectedFromCode(flight?.code);
        setSelectedFromName(flight?.name);
        const formattedFromCity = flight?.city?.toLowerCase().replace(/\s+/g, '-');
        const formattedToCity = selectedTocity?.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        const resultUrl = `/flights/${urlIdDynamic}`;
        navigate(resultUrl);

        setShowSearchListFrom(false);
        setTopCityData(false);
        setIsButtonClick(true);
        sessionStorage.removeItem('airlineName');
        sessionStorage.removeItem("comeFromReview");
    };

    const handleSelectToFlight = (flight) => {
        if (flight.cityCode === selectedFromCode) {
            setErrorSameCitySelect(true);
            return;
        }

        setSelectedTocity(flight?.city);
        setSelectedToCode(flight?.code);
        setSelectedToName(flight?.name);

        const formattedFromCity = selectedFromCity?.toLowerCase().replace(/\s+/g, '-');
        const formattedToCity = flight?.city?.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        const resultUrl = `/flights/${urlIdDynamic}`;
        navigate(resultUrl);

        setShowSearchListTo(false);
        setTopCityData(false);
        setIsButtonClick(true);
        sessionStorage.removeItem('airlineName');
        sessionStorage.removeItem("comeFromReview");
    };

    const showSearchFrom = () => {
        setShowSearchListFrom(!showSearchListFrom);
        setShowSearchListTo(false);
        setTopCityData(true)
        if (!showSearchListFrom) {
            fetchCountryList(searchTermFrom);
        }
    };

    const showSearchTo = () => {
        setShowSearchListTo(!showSearchListTo)
        setShowSearchListFrom(false);
        setTopCityData(true)
        if (!showSearchListTo) {
            fetchCountryList(searchTermTo);
        }
    };

    const handleInputChange = (e) => {
        setSearchTermFrom(e.target.value);
        fetchCountryList(e.target.value);
        setTopCityData(e.target.value === '');
        setErrorSameCitySelect(false)
    };

    const handleInputToChange = (e) => {
        const value = e.target.value;
        setSearchTermTo(value);
        fetchCountryList(value);
        setTopCityData(value === '');
        setErrorSameCitySelect(false)
    };

    const handleExchange = () => {
        setSelectedFromCity(selectedTocity);
        setSelectedTocity(selectedFromCity);
        setSelectedFromCode(selectedToCode)
        setSelectedToCode(selectedFromCode)
        setSelectedFromName(selectedToName);
        setSelectedToName(selectedFromName);
        setIsButtonClick(true);
    };

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.removeItem("comeFromReview");
        };
        const handleKeyDown = (e) => {
            if ((e.ctrlKey && e.key === 'r') || e.key === 'F5') {
                sessionStorage.removeItem("comeFromReview");
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);



    const navigate = useNavigate()

    const extractRouteDataFromUrl = () => {
        const pathSegments = location.pathname.split('/').pop().split('-flights')[0];
        const [fromCity, toCity] = pathSegments.split('-to-');
        return {
            fromCity: fromCity || '',
            toCity: toCity || '',
        };
    };

    const { fromCity, toCity } = extractRouteDataFromUrl();
    const [cityCodes, setCityCodes] = useState({ fromCityCode: '', toCityCode: '' });
    const [selectedFromCode, setSelectedFromCode] = useState('');
    const [selectedToCode, setSelectedToCode] = useState('');
    const [selectedFromName, setSelectedFromName] = useState('');
    const [selectedToName, setSelectedToName] = useState('');



    useEffect(() => {
        const fetchCityCodes = async () => {
            try {
                const cleanFromCity = fromCity.replace(/\-/g, ' ').trim();
                const cleanToCity = toCity.replace(/\-/g, ' ').trim();
                const fromCityCode = await dispatch(fetchFlightCountryList(cleanFromCity)).unwrap();
                const toCityCode = await dispatch(fetchFlightCountryList(cleanToCity)).unwrap();

                setCityCodes({ fromCityCode, toCityCode });
                setSelectedFromCity(fromCityCode[0]?.city || '');
                setSelectedFromCode(fromCityCode[0]?.cityCode || '');
                setSelectedTocity(toCityCode[0]?.city || '');
                setSelectedToCode(toCityCode[0]?.cityCode || '');
                setSelectedFromName(fromCityCode[0]?.name || '');
                setSelectedToName(toCityCode[0]?.name || '');
            } catch (error) {
                console.error('Error fetching city codes:', error);
            }
        };


        if (fromCity && toCity) {
            fetchCityCodes();
        }
    }, [dispatch, fromCity, toCity]);

    const API_DATE_FORMAT = "YYYY-MM-DD";
    const LOCAL_DATE_FORMAT = "DD/MMM/YYYY";

    const formatDate = (date) => {
        if (!date) return moment().format("YYYY-MM-DD");
        return moment(date, "DD/MMM/YYYY").format("YYYY-MM-DD");
    };
    const fetchOneWayFlightUpdate = () => {

        if (!selectedFromCode || !selectedToCode) return

        if (isButtonClick) {
            setIsButtonClick(false);
            return;
        }

        const searchParams = new URLSearchParams(location.search);
        let departureDateFromURL = searchParams.get("departure_date");
        let travelDateMoment;
        if (departureDateFromURL) {
            const today = moment().startOf("day");
            const parsedDate = moment(departureDateFromURL, API_DATE_FORMAT, true);

            travelDateMoment = parsedDate.isValid()
                ? parsedDate.isBefore(today)
                    ? moment().add(1, "day")
                    : parsedDate
                : moment().add(1, "day");
        }
        else {
            const cleanedFindDay = findDay.replace(/^"|"$/g, '');
            const parsedFindDay = moment(cleanedFindDay, LOCAL_DATE_FORMAT, true);
            travelDateMoment = parsedFindDay.isValid()
                ? parsedFindDay
                : moment().add(1, "day");
        }

        const travelDateForAPI = travelDateMoment.format(API_DATE_FORMAT);
        const travelDateForStorage = travelDateMoment.format(LOCAL_DATE_FORMAT);
        const adultsCount = selectAdults || 1;
        const childrenCount = selectchildren || 0;
        const infantsCount = selectInfants || 0;
        const cabinClass = seatType || "ECONOMY";

        const reqBody = {
            cabinClass,
            routeInfos: [
                {
                    fromCityOrAirport: { code: selectedFromCode },
                    toCityOrAirport: { code: selectedToCode },
                    travelDate: travelDateForAPI,
                },
            ],
            paxInfo: {
                ADULT: adultsCount.toString(),
                CHILD: childrenCount.toString(),
                INFANT: infantsCount.toString(),
            },
        };
        sessionStorage.setItem('selectFromCity', JSON.stringify(selectedFromCity));
        sessionStorage.setItem("DepartureFlight", JSON.stringify(travelDateForStorage));
        sessionStorage.setItem('selectTOCity', JSON.stringify(selectedTocity));
        sessionStorage.setItem('findDayReturnFlight', JSON.stringify(findDayRetrun));
        sessionStorage.setItem('selectAdultsflight', JSON.stringify(adultsCount));
        sessionStorage.setItem('selectChildflight', JSON.stringify(childrenCount));
        sessionStorage.setItem('selectInfantsflight', JSON.stringify(infantsCount));
        sessionStorage.setItem('seatTypeflight', JSON.stringify(cabinClass));
        sessionStorage.setItem('returnFlight', JSON.stringify(returnFlights));
        sessionStorage.setItem('selectedFromCode', JSON.stringify(selectedFromCode));
        sessionStorage.setItem('selectedToCode', JSON.stringify(selectedToCode));
        dispatch(setCities({ fromCity: selectedFromCity, toCity: selectedTocity }));
        dispatch(fetchOneWayFlightList({ reqBody }));
        handleClearFilters();
        showSearch();
    };

    const fetchRoundCityFlights = () => {
        if (isButtonClick) {
            setIsButtonClick(false);
            return;
        }

        const travelDate = formatDate(findDay);
        const travelDateReturn = formatDate(findDayRetrun);

        const fromCode = selectedFromCode === "LSQ" ? "LAX" : selectedFromCode;
        const toCode = selectedToCode === "LSQ" ? "LAX" : selectedToCode;

        const reqBody = {
            cabinClass: seatType,
            routeInfos: [
                {
                    fromCityOrAirport: { code: fromCode },
                    toCityOrAirport: { code: toCode },
                    travelDate: travelDate,
                },
                {
                    fromCityOrAirport: { code: toCode },
                    toCityOrAirport: { code: fromCode },
                    travelDate: travelDateReturn,
                },
            ],
            paxInfo: {
                ADULT: selectAdults.toString(),
                CHILD: selectchildren.toString(),
                INFANT: selectInfants.toString()
            },
        };

        dispatch(fetchRoundCityFlightFilterList({ reqBody }))
        // sessionStorage.setItem('DepartureFlight', JSON.stringify(findDay));
        sessionStorage.setItem('selectAdultsflight', JSON.stringify(selectAdults));
        sessionStorage.setItem('selectChildflight', JSON.stringify(selectchildren));
        sessionStorage.setItem('selectInfantsflight', JSON.stringify(selectInfants));
        sessionStorage.setItem('seatTypeflight', JSON.stringify(seatType));
        sessionStorage.setItem('findDayReturnFlight', JSON.stringify(findDayRetrun));
        sessionStorage.setItem('returnFlight', JSON.stringify(returnFlights));
        // Construct dynamic URL and navigate
        const formattedFromCity = selectedFromCity?.toLowerCase().replace(/\s+/g, '-');
        const formattedToCity = selectedTocity?.toLowerCase().replace(/\s+/g, '-');
        dispatch(setCities({ fromCity: selectedFromCity, toCity: selectedTocity }));
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        const resultUrl = `/flights/${urlIdDynamic}`;
        navigate(resultUrl);
        handleClearFilters();
        showSearch();
    };

    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        if (!selectedFromCode || !selectedToCode) {
            setIsButtonDisabled(true);
        } else {
            setIsButtonDisabled(false);
        }
    }, [selectedFromCode, selectedToCode]);

    const fetchContentData = () => {
        if (!selectedFromCode || !selectedToCode) {
            return;
        }
        if (isButtonClick) {
            setIsButtonClick(false);
            return;
        }
        dispatch(fetchFlightContent({ fromCode: selectedFromCode, toCode: selectedToCode }));
    };

    useEffect(() => {
        const came = sessionStorage.getItem("comeFromReview");

        if (came === "true") {
            console.log("Back from review → NO API CALL");
            return;
        }
        sessionStorage.removeItem("comeFromReview");

        if (returnFlights === "oneWay" && selectedFromCode && selectedToCode) {
            fetchOneWayFlightUpdate();
            fetchContentData();
        }
        if (returnFlights === "roundTrip" && selectedFromCode && selectedToCode) {
            fetchRoundCityFlights();
            fetchContentData();
        }
    }, [selectedFromCode, selectedToCode]);

    let travellers = selectchildren + selectInfants + selectAdults

    const totalPassengers = selectAdults + selectchildren + selectInfants;
    const [passengerLimitReached, setPassengerLimitReached] = useState(null);

    useEffect(() => {
        if (totalPassengers >= 12) {
            setPassengerLimitReached(true);
        } else {
            setPassengerLimitReached(false);
        }
    }, [totalPassengers]);


    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isReturnDrawerOpen, setIsReturnDrawerOpen] = useState(false);

    const today = moment();

    const generateCalendarReturn = () => {
        const calendar = [];
        const endOfYear = today.clone().add(1, "year").endOf("year");
        let current = today.clone().startOf("month");

        while (current.isBefore(endOfYear, "month")) {
            const daysInMonth = current.daysInMonth();
            const startDay = current.clone().startOf("month").day();

            const monthData = {
                month: current.format("MMMM YYYY"),
                days: [],
            };

            for (let i = 0; i < startDay; i++) {
                monthData.days.push(null);
            }

            for (let day = 1; day <= daysInMonth; day++) {
                const date = current.clone().date(day);
                monthData.days.push(date);
            }

            calendar.push(monthData);
            current.add(1, "month");
        }

        return calendar;
    };

    const calendarData = generateCalendarReturn();

    const handleDateSelect = (date) => {
        if (!date || date.isBefore(today, "day")) return;
        setFindDay(date.format("DD/MMM/YYYY"));
        setIsDrawerOpen(false);
        setFindDayRetrun(date.format("DD/MMM/YYYY"));
        setIsReturnDrawerOpen(true);
    };

    const handleReturnDateSelect = (date) => {
        const departureDate = moment(findDay, "DD/MMM/YYYY");
        if (!date || !departureDate || date.isBefore(departureDate, "day")) return;
        const weekday = date.format("dddd");
        setFindDayRetrun(date.format("DD/MMM/YYYY"));
        setIsReturnDrawerOpen(false);
    };

    const filteredCalendarData = calendarData.filter((month) => {
        const firstDate = month.days.find((date) => date);
        return firstDate && firstDate.isSameOrAfter(today, "month");
    });

    const filteredReturnCalendarData = calendarData.filter((month) => {
        const firstDate = month.days.find((date) => date);
        const departureDate = findDay ? moment(findDay, "DD/MMM/YYYY") : null;
        return (
            firstDate &&
            departureDate &&
            firstDate.isSameOrAfter(departureDate, "month")
        );
    });

    const formatDateFlight = (date) => {
        const parsedDate = moment(date, "DD/MMM/YYYY", true);
        if (parsedDate.isValid()) {
            return parsedDate.format("DD/MMM/YY");
        } else {
            return moment().format("DD/MMM/YY");
        }
    };



    return (
        <>
            {isVisible &&
                <ResultFilter setIsVisible={setIsVisible} />
            }

            {isVisibleRoundTrip &&
                <RoundTripFilter
                    setIsVisibleRoundTrip={setIsVisibleRoundTrip}
                    setArrivalDataReturn={setArrivalDataReturn}
                    setDepartureData={setDepartureData}
                    setSelectedValueReturn={setSelectedValueReturn}
                    setSelectedValue={setSelectedValue}
                    setShouldLoadOnward={setShouldLoadOnward}
                    setShouldLoadReturn={setShouldLoadReturn}
                />
            }

            <section className={location?.pathname !== "/result-page" ? "head-box-cntr-result pb-0" : "head-box-cntr-result"}>
                <div ref={bannerSearch} className={`Banner_cntr mt-0 pt-0 ${isMobileView && !isSearchVisible ? 'd-none' : ''}`}>
                    <div className="container">
                        <Row gutter={16} className='w-100 justify-content-center m-0 d-block'>
                            <Card style={{ borderRadius: "0 0 20px 20px" }}>

                                <div className='d-flex justify-content mb-2'>
                                    <Radio.Group
                                        defaultValue={returnFlights}
                                        value={returnFlights}
                                        onChange={onChangeTrip}
                                    >
                                        <Radio value="oneWay">One Way</Radio>
                                        <Radio value="roundTrip">Round Trip</Radio>
                                    </Radio.Group>
                                </div>

                                <Row gutter={16} className='align-items-center'>

                                    <Col lg={8} md={24} className='w-100 from_to_box pe-lg-0 mb-md-2 mb-lg-0'>
                                        <Row gutter={16} className="flight_change">
                                            <Col md={12} xs={12} className='w-100 flight_from_box pe-1'>
                                                {/* From Box */}
                                                <div className='flight_from cursor-pointer' onClick={showSearchFrom}>
                                                    <label className='from-title cursor-pointer'><img src={icons.TakeOffPlane} alt='From' />From</label>
                                                    <button className='flight_from-search-btn' aria-label="select from city">
                                                        <span className='flight-select-title text-truncate'>{selectedFromCity || flightData?.selectFromCity}</span>
                                                    </button>
                                                </div>
                                                {showSearchListFrom && (
                                                    <div ref={popoverFromRef} className='search-list-container'>
                                                        <label className='from-title cursor-pointer'><img src={icons.TakeOffPlane} alt='From' />From</label>
                                                        <Input size="large" status={errorSameCitySelect && "error"} className='mb-2' placeholder="From ..." value={searchTermFrom} onChange={handleInputChange} style={{ height: "60px" }} ref={inputRef} prefix={<FaSearch className='mx-1' />} />
                                                        {errorSameCitySelect ? (
                                                            <span className='destination-source-error mb-2'>Source and destination cannot be the same</span>
                                                        ) : null}
                                                        <ul className='search-list my-2'>
                                                            {topCityData ? (
                                                                <ul className="flight-list">
                                                                    <span className='mx23'>POPULAR CITIES</span>
                                                                    {topTanCity?.map((flight, index) => (
                                                                        <li key={index} onClick={() => handleSelectFromFlight(flight)} className="flight-item">
                                                                            <div className="flight-details">
                                                                                <span className="icon">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                                        <g>
                                                                                            <path fill="none" d="M0 0h24v24H0z" />
                                                                                            <path d="M10.478 11.632L5.968 4.56l1.931-.518 6.951 6.42 5.262-1.41a1.5 1.5 0 0 1 .776 2.898L5.916 15.96l-.776-2.898.241-.065 2.467 2.445-2.626.704a1 1 0 0 1-1.133-.48L1.466 10.94l1.449-.388 2.466 2.445 5.097-1.366zM4 19h16v2H4v-2z" />
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                                <div className="flight-info" style={{ lineHeight: '16px' }}>
                                                                                    <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                                    <span className='airportSubTitle'>{flight?.name}</span><br />
                                                                                    <span className="airportTitle">{flight.flight_country}</span>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            ) : (
                                                                <ul className="flight-list">
                                                                    <span className='mx23' style={{ textTransform: 'uppercase' }}>Suggested Cities</span>
                                                                    {flightList?.map((flight, index) => (
                                                                        <li key={index} onClick={() => handleSelectFromFlight(flight)} className="flight-item">
                                                                            <div className="flight-details">
                                                                                <span className="icon">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                                        <g>
                                                                                            <path fill="none" d="M0 0h24v24H0z" />
                                                                                            <path d="M10.478 11.632L5.968 4.56l1.931-.518 6.951 6.42 5.262-1.41a1.5 1.5 0 0 1 .776 2.898L5.916 15.96l-.776-2.898.241-.065 2.467 2.445-2.626.704a1 1 0 0 1-1.133-.48L1.466 10.94l1.449-.388 2.466 2.445 5.097-1.366zM4 19h16v2H4v-2z" />
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                                <div className="flight-info" style={{ lineHeight: '16px' }}>
                                                                                    <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                                    <span className='airportSubTitle'>{flight?.name}</span><br />
                                                                                    <span className="airportTitle">{flight.flight_country}</span>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </ul>
                                                    </div>
                                                )}
                                            </Col>

                                            {/* Exchange Button */}
                                            <Button className="exchange_icon" id="swap" onClick={handleExchange} aria-label="swap location">
                                                <img src={icons.ExchangeArrow} alt='Exchange Arrow' />
                                            </Button>

                                            <Col md={12} xs={12} className='w-100 flight_to_box ps-1'>
                                                {/* To Box */}
                                                <div className='flight_from cursor-pointer' onClick={showSearchTo}>
                                                    <label className='from-title cursor-pointer'><img src={icons.LandingPlane} alt='To' /> To</label>
                                                    <button className='flight_from-search-btn' aria-label="to city">
                                                        <span className='flight-select-title text-truncate'>{selectedTocity || flightData?.selectTOCity}</span>
                                                    </button>
                                                </div>
                                                {showSearchListTo && (
                                                    <div ref={popoverToRef} className='search-list-container'>
                                                        <label className='from-title cursor-pointer'><img src={icons.LandingPlane} alt='To' /> To</label>
                                                        <Input size="large" status={errorSameCitySelect && "error"} className='mb-2' placeholder="To ..." value={searchTermTo} onChange={handleInputToChange} style={{ height: "60px" }} prefix={<FaSearch className='mx-1' />} ref={inputRef} />
                                                        <ul className='search-list my-2'>
                                                            {topCityData ? (
                                                                <ul>
                                                                    {errorSameCitySelect ? (
                                                                        <span className='destination-source-error mb-2'>Source and destination cannot be the same</span>
                                                                    ) : null}<br />
                                                                    <span className='mx23'>POPULAR CITIES</span>
                                                                    {topTanCity?.map((flight, index) => (
                                                                        <li key={index} onClick={() => handleSelectToFlight(flight)} className="flight-item">
                                                                            <div className="flight-details">
                                                                                <span className="icon">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                                        <g>
                                                                                            <path fill="none" d="M0 0h24v24H0z" />
                                                                                            <path d="M10.254 10.47l-.37-8.382 1.933.518 2.81 9.035 5.261 1.41a1.5 1.5 0 1 1-.776 2.898L4.14 11.937l.776-2.898.242.065.914 3.35-2.627-.703a1 1 0 0 1-.74-.983l.09-5.403 1.449.388.914 3.351 5.096 1.366zM4 19h16v2H4v-2z" />
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                                <div className="flight-info" style={{ lineHeight: '16px' }}>
                                                                                    <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                                    <span className='airportSubTitle'>{flight?.name}</span><br />
                                                                                    <span className="airportTitle">{flight.flight_country}</span>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>

                                                            ) : (
                                                                <>
                                                                    <ul className="flight-list">
                                                                        {errorSameCitySelect ? (
                                                                            <span className='destination-source-error mb-2'>Source and destination cannot be the same</span>
                                                                        ) : null}<br />
                                                                        <span className='mx23' style={{ textTransform: 'uppercase' }}>Suggested Cities</span>
                                                                        {flightList?.map((flight, index) => (
                                                                            <li key={index} onClick={() => handleSelectToFlight(flight)} className="flight-item">
                                                                                <div className="flight-details">
                                                                                    <span className="icon">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                                            <g>
                                                                                                <path fill="none" d="M0 0h24v24H0z" />
                                                                                                <path d="M10.254 10.47l-.37-8.382 1.933.518 2.81 9.035 5.261 1.41a1.5 1.5 0 1 1-.776 2.898L4.14 11.937l.776-2.898.242.065.914 3.35-2.627-.703a1 1 0 0 1-.74-.983l.09-5.403 1.449.388.914 3.351 5.096 1.366zM4 19h16v2H4v-2z" />
                                                                                            </g>
                                                                                        </svg>
                                                                                    </span>
                                                                                    <div style={{ lineHeight: '16px' }}>
                                                                                        <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                                        <span className='airportSubTitle'>{flight?.name}</span><br />
                                                                                        <span className="airportTitle">{flight.flight_country}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </>
                                                            )}

                                                        </ul>
                                                    </div>
                                                )}
                                            </Col>

                                        </Row>
                                    </Col >

                                    <Col lg={13} md={24} className='from_to_box ps-lg-1 mb-md-2 mb-lg-0'>
                                        <Row>
                                            {/* <Col md={returnFlights !== "multiCity" ? 14 : 10}> */}
                                            <Col md={14} lg={14} xs={24} >
                                                <Row>
                                                    <Col span={returnFlights !== "multiCity" ? 12 : 24} className="pe-md-1 ps-md-1 w-100  pe-2 pe-md-0 d-none d-md-block">
                                                        <div className='flight_from' onClick={handleDivClick}>
                                                            <label>
                                                                <img src={icons.Calendar} alt='Departure' />
                                                                Departure</label>
                                                            <DatePicker
                                                                ref={datePickerRef}
                                                                variant="bordered"
                                                                onChange={onChangeDeparture}
                                                                open={isDatePickerOpen}
                                                                value={findDay ? dayjs(findDay, dateFormat) : null}
                                                                format={dateFormat}
                                                                showNow={false}
                                                                disabledDate={disabledPastDate}
                                                                onOpenChange={(status) => setIsDatePickerOpen(status)}
                                                            />
                                                        </div>
                                                    </Col>

                                                    {returnFlights !== "multiCity" &&
                                                        <Col span={12} className="pe-md-1 ps-md-1 w-100 d-none d-md-block">
                                                            {returnFlights === "roundTrip" && (
                                                                <span className='rxCrossReturn' onClick={crossReturnDate}> <FaTimes /></span>
                                                            )}
                                                            <div className='flight_from position-relative' onClick={roundTrip}>
                                                                <div ref={wrapperRefReturn} onClick={handleDivClickReturn} style={{ cursor: 'pointer' }}>
                                                                    <label>
                                                                        <img src={icons.Calendar} alt='Departure' />
                                                                        Return </label>
                                                                    {returnFlights === "roundTrip" && (
                                                                        <>
                                                                            <DatePicker
                                                                                ref={datePickerRefReturn}

                                                                                onChange={onChangeReturn}
                                                                                // value={findDayRetrun ? dayjs(findDayRetrun, dateFormat) : null}
                                                                                value={
                                                                                    findDayRetrun
                                                                                        ? dayjs(findDayRetrun, dateFormat)
                                                                                        : null
                                                                                }
                                                                                format={dateFormat}
                                                                                showNow={false}
                                                                                variant="bordered"
                                                                                disabledDate={(current) =>
                                                                                    current && current < dayjs(findDay).startOf("day")
                                                                                }
                                                                                open={isDatePickerOpenReturn}
                                                                                onOpenChange={(status) =>
                                                                                    setIsDatePickerOpenReturn(status)
                                                                                }
                                                                            />

                                                                        </>
                                                                    )}
                                                                    {returnFlights !== "roundTrip" && (
                                                                        <p>Add a return flight </p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    }

                                                    {/* Mobile View */}
                                                    <Col span={returnFlights !== "multiCity" ? 12 : 24} className="pe-md-1 ps-md-1 w-100 pe-1 d-md-none">
                                                        <div
                                                            onClick={() => setIsDrawerOpen(true)}
                                                            className="open-calendar-btn select-date"
                                                        >
                                                            <div className='flight_from' style={{ cursor: 'pointer' }}>
                                                                <label className=''>
                                                                    <img src={icons.Calendar} alt='Departure' />
                                                                    Departure</label>
                                                                <div>
                                                                    {findDay}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <Drawer
                                                            title="Add Departure Date"
                                                            placement="bottom"
                                                            onClose={() => setIsDrawerOpen(false)}
                                                            open={isDrawerOpen}
                                                            height="85vh"
                                                            className="calendar-drawer"
                                                            closeIcon={null}
                                                            styles={{ header: { textAlign: "right" } }}
                                                            extra={
                                                                <div
                                                                    type="text"
                                                                    onClick={() => setIsDrawerOpen(false)}
                                                                    className="custom-close-icon mt-2"
                                                                    style={{ color: "#fff" }}
                                                                >
                                                                    <FaRegTimesCircle fontSize={25} />
                                                                </div>
                                                            }
                                                        >
                                                            <div className="calendar-container">
                                                                {filteredCalendarData.map((month, index) => (
                                                                    <div key={index} className="month-section">
                                                                        <h4 className="month-title">{month.month}</h4>
                                                                        <div className="day-labels">
                                                                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                                                                <div key={day} className="day-label">
                                                                                    {day}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        {/* <div className="dates-grid">
                                                                        {month.days.map((date, idx) => (
                                                                            <div
                                                                                key={idx}
                                                                                className={`date-cell ${!date
                                                                                    ? "empty"
                                                                                    : date.isBefore(today, "day")
                                                                                        ? "disabled"
                                                                                        : date.isSame(moment(findDay), "day")
                                                                                            ? "selected"
                                                                                            : ""
                                                                                    }`}
                                                                                onClick={() => handleDateSelect(date)}
                                                                            >
                                                                                {date ? (
                                                                                    <>
                                                                                        <div className="date">{date.format("D")}</div>
                                                                                    </>
                                                                                ) : null}
                                                                            </div>
                                                                        ))}
                                                                    </div> */}

                                                                        <div className="dates-grid">
                                                                            {month.days.map((date, idx) => (
                                                                                <div
                                                                                    key={idx}
                                                                                    className={`date-cell ${!date
                                                                                        ? "empty"
                                                                                        : date.isBefore(today, "day")
                                                                                            ? "disabled"
                                                                                            : date.isSame(moment(findDay, "DD/MMM/YYYY"), "day") // <-- FIXED HERE
                                                                                                ? "selected"
                                                                                                : ""
                                                                                        }`}
                                                                                    onClick={() => handleDateSelect(date)}
                                                                                >
                                                                                    {date ? (
                                                                                        <>
                                                                                            <div className="date">{date.format("D")}</div>
                                                                                        </>
                                                                                    ) : null}
                                                                                </div>
                                                                            ))}
                                                                        </div>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Drawer>
                                                        {/* <span>{findDay ? moment(findDay, 'DD/MMM/YYYY').format('dddd') : 'Select Date'}</span> */}

                                                    </Col>

                                                    {returnFlights !== "multiCity" && (
                                                        <Col span={12} className="pe-md-1 ps-md-1 ps-1 w-100 d-md-none">
                                                            {returnFlights === "roundTrip" && (
                                                                <div onClick={crossReturnDate}>
                                                                    <span className='rxCrossReturnMobile' >
                                                                        <FaTimes />
                                                                    </span>
                                                                </div>)}
                                                            <div
                                                                onClick={() => setIsReturnDrawerOpen(true)}
                                                                className="select-date"
                                                            >

                                                                <div className="flight_from" style={{ cursor: 'pointer' }} onClick={roundTrip}>
                                                                    <label>
                                                                        <img src={icons.Calendar} alt='Departure' />
                                                                        Return</label>
                                                                    {returnFlights !== "roundTrip" && (
                                                                        <>
                                                                            <p>Add a return flight</p>
                                                                        </>
                                                                    )}

                                                                    <div>
                                                                        {returnFlights === "roundTrip" && (
                                                                            <>
                                                                                <div>
                                                                                    {findDayRetrun}
                                                                                </div>
                                                                                {/* <span>{findDayRetrun ? moment(findDayRetrun, 'DD/MMM/YYYY').format('dddd') : 'Select Date'}</span> */}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <>
                                                                {returnFlights === "roundTrip" ? (
                                                                    <>
                                                                        <Drawer
                                                                            title="Add Return Date"
                                                                            placement="bottom"
                                                                            onClose={() => setIsReturnDrawerOpen(false)}
                                                                            open={isReturnDrawerOpen}
                                                                            height="85vh"
                                                                            className="calendar-drawer"
                                                                            closeIcon={null}
                                                                            styles={{ header: { textAlign: "right" } }}
                                                                            extra={
                                                                                <div
                                                                                    onClick={() => setIsReturnDrawerOpen(false)}
                                                                                    className="custom-close-icon mt-2"
                                                                                    style={{ color: '#fff' }}
                                                                                >
                                                                                    <FaRegTimesCircle fontSize={25} />
                                                                                </div>
                                                                            }
                                                                        >
                                                                            <div className="calendar-container">
                                                                                {filteredReturnCalendarData.map((month, index) => (
                                                                                    <div key={index} className="month-section">
                                                                                        <h4 className="month-title">{month.month}</h4>
                                                                                        <div className="day-labels">
                                                                                            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                                                                                <div key={day} className="day-label">{day}</div>
                                                                                            ))}
                                                                                        </div>
                                                                                        {/* <div className="dates-grid">
                                                                                        {month.days.map((date, idx) => {
                                                                                            const departureDate = moment(findDay, "DD/MMM/YYYY");
                                                                                            return (
                                                                                                <div
                                                                                                    key={idx}
                                                                                                    className={`date-cell ${!date
                                                                                                        ? "empty"
                                                                                                        : date.isBefore(departureDate, "day")
                                                                                                            ? "disabled"
                                                                                                            : date.isSame(moment(findDayRetrun), "day")
                                                                                                                ? "selected"
                                                                                                                : ""
                                                                                                        }`}
                                                                                                    onClick={() => handleReturnDateSelect(date)}
                                                                                                >
                                                                                                    {date ? (
                                                                                                        <div className="date">{date.format("D")}</div>
                                                                                                    ) : null}
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                    </div> */}
                                                                                        <div className="dates-grid">
                                                                                            {month.days.map((date, idx) => {
                                                                                                const departureDate = moment(findDay, "DD/MMM/YYYY");
                                                                                                const returnDate = moment(findDayRetrun, "DD/MMM/YYYY");

                                                                                                return (
                                                                                                    <div
                                                                                                        key={idx}
                                                                                                        className={`date-cell ${!date
                                                                                                            ? "empty"
                                                                                                            : date.isBefore(departureDate, "day")
                                                                                                                ? "disabled"
                                                                                                                : date.isSame(returnDate, "day")
                                                                                                                    ? "selected"
                                                                                                                    : ""
                                                                                                            }`}
                                                                                                        onClick={() => handleReturnDateSelect(date)}
                                                                                                    >
                                                                                                        {date ? <div className="date">{date.format("D")}</div> : null}
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </div>

                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </Drawer>
                                                                        {/* {selectedReturnDate} */}

                                                                    </>
                                                                ) : null}
                                                            </>
                                                        </Col>
                                                    )}

                                                </Row>
                                            </Col>

                                            <Col md={10} lg={10} xs={24} className="ps-md-1 w-100">
                                                <Popover
                                                    content={
                                                        <>
                                                            <Form className='popup-form'>
                                                                <div className='popup-inner'>
                                                                    <div className='select-adult mb-3'>
                                                                        <div>
                                                                            <h6 className={infantsError && "destination-source-error"}>Adults</h6>
                                                                            <p>(Aged 12+ yrs)</p>
                                                                        </div>
                                                                        <span className='selection'>
                                                                            <Button className='me-3' onClick={removeAdults} aria-label="remove adults">-</Button>
                                                                            <span className='me-3'>{selectAdults}</span>
                                                                            <Button disabled={passengerLimitReached} onClick={addAdults} aria-label="add adults">+</Button>
                                                                        </span>
                                                                    </div>

                                                                    <div className='select-child  mb-3'>
                                                                        <div>
                                                                            <h6>Children</h6>
                                                                            <p>(Aged 2-12 yrs)</p>
                                                                        </div>
                                                                        <span className='selection'>
                                                                            <Button className='me-3' onClick={removeChildern} aria-label="remove child">-</Button>
                                                                            <span className='me-3'>{selectchildren}</span>
                                                                            <Button disabled={passengerLimitReached} onClick={addChildern} aria-label="add child">+</Button>
                                                                        </span>
                                                                    </div>

                                                                    <div className='select-room  mb-3'>
                                                                        <div>
                                                                            <h6 className={infantsError && "destination-source-error"}>Infants</h6>
                                                                            <p>(Below 2 yrs)</p>
                                                                        </div>
                                                                        <span className='selection'>
                                                                            <Button className='me-3' onClick={removeInfants} aria-label="remove infants">-</Button>
                                                                            <span className='me-3'>{selectInfants}</span>
                                                                            <Button disabled={passengerLimitReached} onClick={addInfants} aria-label="add intants">+</Button>
                                                                        </span>
                                                                    </div>

                                                                    {infantsError &&
                                                                        <p className='destination-source-error mb-2'>You must have atleast one adult per infant</p>
                                                                    }
                                                                    <h4 className='mb-2'>Travel Class</h4>
                                                                    <Radio.Group defaultValue={seatType} onChange={(e) => setSeatType(e.target.value)}>
                                                                        <Radio value="ECONOMY">Economy</Radio>
                                                                        <Radio value="PREMIUM_ECONOMY">Premium</Radio>
                                                                        <Radio value="BUSINESS">Business</Radio>
                                                                        <Radio value="FIRST">First Class</Radio>
                                                                    </Radio.Group>

                                                                </div>
                                                                <div className='popup-footer'>
                                                                    <Button onClick={() => {
                                                                        setOpen(false);
                                                                        sessionStorage.removeItem('airlineName');
                                                                    }} aria-label="Add Trevellers and class" className='w-100 btn btn-primary'>Done</Button>
                                                                </div>
                                                            </Form>
                                                        </>}
                                                    placement="bottom"
                                                    trigger="click"
                                                    open={open}
                                                    onOpenChange={() => setOpen(true)}
                                                >
                                                    <div style={infantsError ? { borderColor: "red" } : {}} className='flight_from'>

                                                        <label>
                                                            <img src={icons.Users} alt='Travelers & Class' />
                                                            Travelers & Class </label>

                                                        <div className="select-acr"
                                                        > <span>{travellers} Traveller(s), </span>
                                                            <span>{travelersClass[seatType]}</span>
                                                        </div>


                                                    </div>
                                                </Popover>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col lg={3} xs={24} className='ps-lg-1 d-flex align-items-center justify-content-between d-md-block'>
                                        <div>
                                            {returnFlights === "oneWay" ? (
                                                <Button
                                                    type="primary"
                                                    onClick={() => {
                                                        fetchOneWayFlightUpdate();
                                                        fetchContentData();
                                                    }}
                                                    disabled={isButtonDisabled || infantsError || loading || open}
                                                    aria-label="Search flights"
                                                >
                                                    Search Flights
                                                </Button>
                                            ) : (
                                                returnFlights === "roundTrip" && (
                                                    <Button
                                                        aria-label="Search roundtrip Flights"
                                                        type="primary"
                                                        onClick={() => {
                                                            fetchRoundCityFlights();
                                                            fetchContentData();
                                                        }}
                                                        disabled={isButtonDisabled || infantsError || loadingRoundTrip || open}
                                                    >
                                                        Search Flights
                                                    </Button>
                                                )
                                            )}

                                        </div>


                                        <a onClick={showSearch} href='#' className="ms-2 fw-bold text-primary btn border-primary py-1 float-end d-md-none">
                                            Hide
                                        </a>
                                    </Col>
                                </Row>

                            </Card>
                        </Row>
                    </div>
                </div>

                {isMobileView && !isSearchVisible && (
                    <div
                        className="result_hide_details m-auto pt-2 d-md-none"
                        style={{ width: '96%' }}
                    >
                        <div className="card mb-0 rounded">
                            <div className="card-body d-flex align-items-center gap-1 position-relative">
                                {/* <h4>{selectedFromCity}</h4> <h4>-</h4> <h4>{selectedTocity}</h4> <h4>|</h4> */}
                                <div>
                                    <div className='d-flex align-items-center mb-1'>
                                        {!selectedFromCity ? (
                                            <div className="spinner mx-2"></div>
                                        ) : (
                                            <>
                                                <h4 className='lh-sm'>{selectedFromCity}</h4>
                                                <h4 className='lh-sm'>-</h4>
                                                <h4 className='lh-sm'>{selectedTocity}</h4>
                                            </>
                                        )}
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <p className='lh-sm'>{formatDateFlight(findDay)}</p> {returnFlights === "roundTrip" && <> <p className='lh-sm'>-</p> <p className='lh-sm'>{formatDateFlight(findDayRetrun)}</p></>}
                                    </div>
                                </div>

                                <div className='mobile-result-button'>
                                    <a className="show-search-btn" onClick={() => setIsSearchVisible(true)}>
                                        <FaEdit className="down" />
                                    </a>

                                    {returnFlights === "oneWay" &&
                                        <a className="show-search-btn" onClick={() => setIsVisible(true)}>
                                            <FaFilter className="down" />
                                        </a>
                                    }

                                    {returnFlights === "roundTrip" &&
                                        <a className="show-search-btn" onClick={() => setIsVisibleRoundTrip(true)}>
                                            <FaFilter className="down" />
                                        </a>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                )}



            </section>


        </>
    );
};


export default SearchFlightsUpdate;